import { Component, OnInit } from '@angular/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { CultureService } from '@app/core/services/system-language/culture.service';
import { TimezoneService } from '@app/core/services/timezone/timezone.service';
import { Organization } from '@app/modules/organization-structure/models/organization-structure.model';
import { WorkLocationsService } from '@app/modules/work-locations/services/work-locations.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { Culture } from '@app/shared/models/system-language/culture.model';
import { Timezone } from '@app/shared/models/timezone.model';
import moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-add-dummy-work-locations',
  templateUrl: './add-dummy-work-locations.component.html',
  styleUrls: ['./add-dummy-work-locations.component.scss']
})
export class AddDummyWorkLocationsComponent implements OnInit {
  loadingTypes: boolean = true;
  loadingOrgs: boolean = true;
  orgs: Organization[];
  numberOfItems: number = 20;
  organizationTypes: Organization[];
  cultures: Culture[];
  timezones: Timezone[];

  constructor(
    private snackbarService: SnackbarService,
    private overlayService: OverlayService,
    private cultureService: CultureService,
    private timezoneService: TimezoneService,
    private workLocationsService: WorkLocationsService,
  ) { }

  ngOnInit(): void {
    this.getCultures();
    this.getTimezones();
  }

  createRandomString(length: number): string {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length);
  }

  getCultures() {
    this.cultureService.getCultures()
    .subscribe(
      res => {
        this.cultures = res;
      }
    )
  }

  getTimezones() {
    this.timezoneService.getTimezones()
    .subscribe(
      res => {
        this.timezones = res.data;
      }
    )
  }

  random_item(items){
    return items[Math.floor(Math.random()*items.length)];
  }

  getNewWorkLocation(): any {
    return {
      "name":[{"culture":"en-CA","text":`Dummy-${this.createRandomString(10)}`}],
      "streetAddress":null,
      "city":null,
      "province":null,
      "zip":null,
      "region":null,
      "country":null,
      "id":null,
      "timezone":this.random_item(this.timezones).id,
      "startDate":null,
      "endDate":null
    }
  }

  createItems() {
    let createItemRequests: Observable<any>[] = [];

    for (let i = 0; i < this.numberOfItems; i++) {
      createItemRequests.push(this.workLocationsService.createWorkLocation(this.getNewWorkLocation()))
    }

    this.overlayService.show();
    forkJoin(createItemRequests)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
        (res) => {
            this.snackbarService.openSnackBar(`Created ${this.numberOfItems} Work Locations(s) Successfully`, 'clear', 'success');
        }
    );
  }
}
